/**
 * 已保存账号列表（账号切换功能的"通讯录"）
 *
 * 存在 localStorage（持久化）：关掉浏览器也必须还在，否则"保存"没有意义。
 * 注意区别：当前登录态（role/学校/孩子）仍存 sessionStorage，随会话结束消失，不要搬过来
 * ——快照不会过期而 sid 会，搬过来会出现"本地显示是老师、实际 sid 已失效"的错配。
 *
 * 每条记录：{ userNo, pwd(加密), role, name, schoolName, savedAt }
 * 其中 pwd 与 localStorage.pwd 同一套加密（AES，见 common/js/utils），
 * 切换账号时解密出来直接调登录接口，用户不用重输密码。
 */

const KEY = "savedAccounts";

/** 读取全部已保存账号；数据损坏时兜底为空数组，避免账号页白屏 */
export function getSavedAccounts() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const list = JSON.parse(raw);
    return Array.isArray(list) ? list : [];
  } catch (e) {
    return [];
  }
}

function writeAll(list) {
  localStorage.setItem(KEY, JSON.stringify(list));
}

/**
 * 保存（或更新）一个账号，按 userNo 去重
 * @param {{userNo:string, pwd:string, role:string|number, name:string, schoolName:string}} item
 */
export function saveAccount(item) {
  if (!item || !item.userNo) return;
  const list = getSavedAccounts();
  const idx = list.findIndex((a) => a.userNo === item.userNo);
  const rec = { ...item, savedAt: Date.now() };
  if (idx > -1) list[idx] = { ...list[idx], ...rec };
  else list.push(rec);
  writeAll(list);
}

/** 移除一个已保存账号 */
export function removeAccount(userNo) {
  writeAll(getSavedAccounts().filter((a) => a.userNo !== userNo));
}

/** 该账号是否已保存 */
export function isSaved(userNo) {
  return getSavedAccounts().some((a) => a.userNo === userNo);
}
